import { useEffect, useState } from 'react';

// Use the short dimension instead of width so phones in landscape stay mobile.
// Phones top out around 430px on the short side; tablets start at 768px.
const SHORT_DIM_THRESHOLD_PX = 500;

function detect(): boolean {
  if (typeof window === 'undefined') return false;
  return Math.min(window.innerWidth, window.innerHeight) < SHORT_DIM_THRESHOLD_PX;
}

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(detect);

  useEffect(() => {
    const onResize = () => setIsMobile(detect());
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
    };
  }, []);

  return isMobile;
}
